<form
  (ngSubmit)="onSave()"
  [formGroup]="form"
>
  <app-content-header text="Marketing Opt-In"></app-content-header>

  <div class="input-container">
    <span class="input-label">I agree to receive emails</span>
    <app-binary-choice-selector
      [opt1]="{ text: 'Allow', value: true }"
      [opt2]="{ text: 'No Thank You', value: false }"
      [selectedValue]="form.get('email').value"
      (selectedValueChange)="form.get('email').patchValue($event)"
    ></app-binary-choice-selector>
  </div>
  <div class="input-container">
    <span class="input-label">I agree to receive SMS messages</span>
    <app-binary-choice-selector
      [opt1]="{ text: 'Allow', value: true }"
      [opt2]="{ text: 'No Thank You', value: false }"
      [selectedValue]="form.get('text').value"
      (selectedValueChange)="form.get('text').patchValue($event)"
    ></app-binary-choice-selector>
  </div>

  <div class="action-container">
    <button
      type="submit"
      class="btn btn-danger btn-block"
      [disabled]="!form.valid"
    >Save</button>
  </div>
</form>